var m;

m = require('mithril');

module.exports = {
  view: function() {
    return m('footer.footer', []);
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2FwcC9zcmMvdWkvY29tcG9uZW50cy9Gb290ZXIuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL2FwcC9zcmMvdWkvY29tcG9uZW50cy9Gb290ZXIuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsQ0FBQSxHQUFJLE9BQUEsQ0FBUSxTQUFSOztBQUVKLE1BQU0sQ0FBQyxPQUFQLEdBQWlCO0VBQ2hCLElBQUEsRUFBTSxTQUFBO1dBQ0wsQ0FBQSxDQUFFLGVBQUYsRUFBbUIsRUFBbkI7RUFESyxDQURVIn0=
